import { render, staticRenderFns } from "./FlatBuy.vue?vue&type=template&id=506bacd9"
import script from "./FlatBuy.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlatBuy.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports